import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-jinru",
  "use": "icon-jinru-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-jinru\"><path d=\"M938.9 828.1c0 49-39.8 88.9-88.8 88.9L668.50000001 917l-1e-8-84.9 181.6 0 4-4 0-649.6-4-4L200.29999999 174.5l-3.99999999 3.99999999L196.3 828.1l4 4L382 832.1 382.00000001 917 200.29999999 917c-48.9 0-88.7-39.9-88.69999999-88.9l0-649.6c0-49 39.8-88.8 88.7-88.8l649.79999999 0c49 0 88.8 39.8 88.8 88.8L938.9 828.1z m-246.6-242.3L574.5 468l-6.8 2.8L567.7 917l-84.9 0 0-446.1-6.8-2.8-117.8 117.7-59.3-59.3 226.4-226.4 226.2 226.4-59.2 59.3z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/jinru.svg
// module id = h4bb
// module chunks = 16